import { CityBreakTickets } from 'components/common/CityBreak/components/CityBreakBox/components/CityBreakTickets'
import Loader from 'components/shared/Loader'
import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import { useAppSelector } from 'store/hooks'
import {
    mergeTickets,
    mergeTicketsBundles,
    sumTicketsBundlesDates,
    sumTicketsDates,
} from 'components/global/Summary/helpers'
import { useApp } from 'store/steps'
import { CartItemTicketDetailDto } from 'store/api-slice/hooks'
import { Person, Time, Zone } from 'store/api-slice/types'

export const CityBreakRegularTickets = () => {
    const { formatMessage } = useIntl()
    const { language } = useApp()

    const { tickets, ticketsBundles } = useAppSelector(
        (state) => state.cart.items
    )

    const dates = tickets.length
        ? sumTicketsDates(tickets)
        : sumTicketsBundlesDates(ticketsBundles)
    const datesRange =
        dates.length === 1 ? [dates[0]] : [dates[0], dates[dates.length - 1]]

    const mergedTickets = [
        ...mergeTicketsBundles({
            ticketsBundles,
            language,
        }),
        ...mergeTickets(tickets),
    ]
    const ticketsData = mergedTickets.map((ticket) => {
        const { quantity, totalPrice, name, detail } = ticket
        const { person, zone, ticketTime } = detail as CartItemTicketDetailDto

        // TODO: move into helpers
        const isFamilyPackage =
            name?.includes('Family') || name?.includes('Сімейний')
        const isSeniorPackage =
            name?.toLowerCase().includes('senior') ||
            name?.toLowerCase().includes('сеньора')

        return {
            quantity: quantity || 0,
            zone: zone as Zone,
            person: person as Person,
            ticketType: (isSeniorPackage ? 'day' : ticketTime) as Time,
            price: totalPrice || 0,
            isFamilyPackage,
            isSeniorPackage,
        }
    })

    return ticketsData.length === 0 ? (
        <Loader />
    ) : (
        <Box mt={24} mb={[0, 16]} isFullWidth>
            <CityBreakTickets
                title={formatMessage({
                    id: 'promo.city_break.park_tickets_to_remove',
                    defaultMessage: '_',
                })}
                datesRange={datesRange}
                tickets={ticketsData}
                daysNumber={dates.length}
            />
        </Box>
    )
}
